// src/components/Popups/StudentBalancePopup.jsx
//
// „Balanța” elevului (se deschide din widget-ul Balanță de pe pagina principală):
// soldul și ultimele operații. Datele vin din useStudentBalance (aceeași sursă ca
// bara de sus și widget-ul). Prima variantă; popup-ul e încă în lucru.

import React from "react";

import { CardUI, ListUI, StatusUI } from "../UI";
import useStudentBalance from "../../hooks/useStudentBalance";
import { BALANCE_TYPE_LABELS, formatLeiShort, splitLei } from "../../api/balanceService";

function shortDate(value) {
   const d = new Date(value);
   if (Number.isNaN(d.getTime())) return "";
   return d.toLocaleString("ro-RO", { day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
}

export default function StudentBalancePopup() {
   const balance = useStudentBalance();
   const { lei, cents } = splitLei(balance.balanceBani);

   return (
      <CardUI level="popup" title="Balanța" className="studentBalance">
         <div className="studentBalance__sold">
            <span className="studentBalance__label">Sold disponibil</span>
            <strong className="studentBalance__amount">
               {lei}
               {cents && <small>,{cents}</small>}
               <span> lei</span>
            </strong>
         </div>

         {!balance.loaded ? (
            <StatusUI tone="loading">Se încarcă…</StatusUI>
         ) : (
            <ListUI title="Ultimele operații" joined={false}>
               {balance.entries.length === 0 && <ListUI.Empty>Nicio operație încă.</ListUI.Empty>}
               {balance.entries.map((entry) => (
                  <ListUI.Item
                     key={entry.id}
                     title={BALANCE_TYPE_LABELS[entry.type] || entry.type}
                     // doar data: notița operației (entry.reason) e pentru personal, elevul n-o vede
                     detail={shortDate(entry.createdAt)}
                     aside={
                        <strong
                           className={
                              "studentBalance__sum" + (entry.amountBani < 0 ? " is-minus" : " is-plus")
                           }
                        >
                           {entry.amountBani > 0 ? "+" : ""}
                           {formatLeiShort(entry.amountBani)}
                        </strong>
                     }
                  />
               ))}
            </ListUI>
         )}
      </CardUI>
   );
}
